import './App.css';
import image from './assets/icons/loading-loader.gif';
import { withAuthenticationRequired } from '@auth0/auth0-react';

// this component serves as a default state for the app
// this should just show the loading gif until the auth0
// function withAuthenticationRequired triggers
// the redirect to the auth0 login

function LoadingAuth0Redirect({}){

    return (
        <div className="loadingScreen">
            <div className="loaderWrapper">
                <img src={image} alt="Loading Gif" style={{ width: '100%' }} />
            </div>
        </div>
    )
}

export default withAuthenticationRequired(LoadingAuth0Redirect);